module.exports = __webpack_public_path__ + "static/media/38@2x.7f34a160.png";